<!--新增编辑-->
<nz-modal *ngIf="isVisible" [(nzVisible)]="isVisible" [nzTitle]="title" nzClosable="false" [nzWidth]="'800px'">
  <ng-container *nzModalContent>
    <nz-table nzSize="middle" [nzFrontPagination]="true" [nzData]="listData" [nzLoading]="tableLoading">
      <thead>
        <tr>
          <th>发布内容</th>
          <th>检测敏感词</th>
          <th>创建时间</th>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr *ngFor="let data of listData; let i = index">
            <td class="td-long-deal" style="width: 250px" nz-tooltip [nzTooltipTitle]="data.content">{{ data?.content }}</td>

            <td>{{ data?.checkWord }}</td>
            <td>{{ data.createdAt | date : 'yyyy-MM-dd HH:mm' }}</td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-container>
  <div *nzModalFooter>
    <div style="margin-top: -5px">
      <button nz-button nzType="default" (click)="close()">关闭</button>
    </div>
  </div>
</nz-modal>
